import React from 'react';

import type { Section } from '../../../../../models';
import { ELECTRICITY } from '../../../../../constants';
import UtilitiesIndividuallyMetered from './UtilitiesIndividuallyMetered';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function ElectricityIndividuallyMetered({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesIndividuallyMetered
      section={section}
      setSectionValues={setSectionValues}
      utilityIndividuallyMeteredField={ELECTRICITY.FIELD_NAME.INDIVIDUALLY_METERED}
      utilityName="Electricity"
    />
  );
}

export default ElectricityIndividuallyMetered;
